var React = require('react');

function Diagonal (props) {
    return React.createElement("svg",props,React.createElement("g",{"id":"Group_1379","data-name":"Group 1379","transform":"translate(0.707 1)"},[React.createElement("line",{"id":"Line_124","data-name":"Line 124","y1":"46.131","x2":"46.131","transform":"translate(0 0)","fill":"none","strokeWidth":"2","key":0}),React.createElement("g",{"id":"Group_369","data-name":"Group 369","transform":"translate(30.754 0)","key":1},[React.createElement("line",{"id":"Line_125","data-name":"Line 125","x2":"15.377","fill":"none","strokeLinecap":"square","strokeWidth":"2","key":0}),React.createElement("line",{"id":"Line_126","data-name":"Line 126","y1":"15.377","transform":"translate(15.377)","fill":"none","strokeLinecap":"square","strokeWidth":"2","key":1})])]));
}

Diagonal.defaultProps = {"viewBox":"0 0 47.839 47.838"};

module.exports = Diagonal;

Diagonal.default = Diagonal;
